import React from 'react';

const CardDiscover = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="16"
      viewBox="0 0 24 16"
      fill="none"
    >
      <g clipPath="url(#clip0_19672_16127)">
        <path
          d="M0 2C0 0.895431 0.895431 0 2 0H22C23.1046 0 24 0.895431 24 2V14C24 15.1046 23.1046 16 22 16H2C0.89543 16 0 15.1046 0 14V2Z"
          fill="#FCE0CF"
        />
        <path
          d="M14.2901 7.99115C14.292 7.56129 14.1308 7.13081 13.8064 6.80641C13.4814 6.48134 13.0498 6.3203 12.6191 6.32289C12.617 6.32289 12.615 6.32275 12.6129 6.32275C11.6775 6.32275 10.9355 7.06452 10.9355 8.00016C10.9355 8.92657 11.6866 9.67744 12.6129 9.67744C13.5485 9.67744 14.2904 8.93554 14.2904 8.00016C14.2904 7.99709 14.2901 7.99419 14.2901 7.99115Z"
          fill="#F26E21"
        />
        <path
          d="M10.6237 8.70967C10.373 8.96065 10.1416 9.0587 9.89234 9.06401C9.28516 9.05856 8.83875 8.6089 8.83875 7.96782C8.83875 7.64511 8.96094 7.38062 9.1545 7.15467C9.33602 6.98234 9.56986 6.871 9.83877 6.871C10.129 6.871 10.3549 6.96776 10.6128 7.22582V6.48392C10.355 6.35496 10.129 6.29041 9.83877 6.29041C9.42871 6.31971 9.04208 6.48539 8.74552 6.74556C8.66005 6.82246 8.57814 6.90736 8.50869 7.00452C8.29206 7.28529 8.16113 7.62909 8.16113 8.0002C8.16113 8.93553 8.9033 9.64518 9.83872 9.64518C9.84327 9.64518 9.84778 9.64478 9.85219 9.64473C9.85848 9.64482 9.86468 9.64518 9.87093 9.64518C10.129 9.64518 10.3549 9.58081 10.6452 9.45175L10.6237 8.70967C10.6128 8.72056 10.6345 8.73068 10.6237 8.74099V8.70967Z"
          fill="#2B2B2B"
        />
        <path
          d="M16.408 6.75241L15.6774 8.54848L14.8387 6.41931H14.1614L15.4839 9.67737H15.8387L17.2258 6.41931H16.5485L16.408 6.75241Z"
          fill="#2B2B2B"
        />
        <path
          d="M17.4839 7.8387V9.58075H19.2259H19.258V9.06444H18.7097H18.129V8.48393V8.1937H19.2259V7.64514H18.129V6.96779H19.258V6.41931H17.4839V7.8387Z"
          fill="#2B2B2B"
        />
        <path
          d="M2.90339 6.41931H2V9.58075H2.90334C3.38714 9.58075 3.74192 9.4516 4.03224 9.22579C4.38702 8.93547 4.61292 8.48398 4.61292 8.00019C4.61296 7.06446 3.93543 6.41931 2.90339 6.41931ZM3.64525 8.80655C3.45169 8.96777 3.19362 9.06444 2.8065 9.06444H2.61294V6.96774H2.7742C3.16132 6.96774 3.41939 7.03225 3.61299 7.22572C3.83876 7.41915 3.96786 7.70964 3.96786 8.00005C4.00012 8.29037 3.87111 8.61281 3.64525 8.80655Z"
          fill="#2B2B2B"
        />
        <path
          d="M5.51646 6.41895H4.90356V9.58029H5.51646V6.41895Z"
          fill="#2B2B2B"
        />
        <path
          d="M7.06459 7.64511C6.67756 7.5161 6.58067 7.41925 6.58067 7.25803C6.58067 7.06447 6.77423 6.90321 7.03229 6.90321C7.22586 6.90321 7.38712 6.96776 7.54843 7.16132L7.87109 6.74199C7.61293 6.51608 7.2905 6.38721 6.93563 6.38721C6.38711 6.38721 5.93548 6.77433 5.93548 7.29028C5.93548 7.742 6.12922 7.93552 6.70977 8.16133C6.96783 8.25796 7.06464 8.29034 7.12928 8.35485C7.25806 8.41926 7.3227 8.54841 7.3227 8.67729C7.3227 8.9354 7.12928 9.129 6.83878 9.129C6.54819 9.129 6.29035 8.96774 6.16129 8.70963L5.77417 9.09675C6.06462 9.51608 6.41945 9.7096 6.87108 9.7096C7.51617 9.7096 7.96758 9.29027 7.96758 8.67729C7.96767 8.12903 7.77429 7.90322 7.06459 7.64511Z"
          fill="#2B2B2B"
        />
        <path
          d="M21.0002 8.25799C21.4839 8.16136 21.742 7.83866 21.742 7.35491C21.742 6.77436 21.3226 6.41931 20.613 6.41931H19.6775V9.58075H20.2904V8.32254H20.3873L21.258 9.58075H22L21.0002 8.25799ZM20.4839 7.87086H20.2904V6.90324H20.4839C20.871 6.90324 21.0969 7.06446 21.0969 7.38725C21.0969 7.70969 20.871 7.87086 20.4839 7.87086Z"
          fill="#2B2B2B"
        />
      </g>
      <defs>
        <clipPath id="clip0_19672_16127">
          <rect width="24" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CardDiscover;
